<mat-progress-bar
  class="meddic-bar"
  [value]="progress"
  [ngClass]="colorClass"
  [mode]="loading ? 'indeterminate' : 'determinate'"
></mat-progress-bar>
<div class="cats-met">
  {{ categoriesMet }}/{{ potentialScoreSum }} {{ 'FRONTEND.SALES_UI.PIPELINE.MEDDIC.POINTS' | translate }}
</div>
